import React from "react";
import "./App.css";

const NoInternet = () => {
  return (
    <div className="no-internet-container">
      <div className="no-internet-content">
        <h1>No Internet Connection</h1>
        <p>Please check your internet connection and try again.</p>
      </div>
    </div>
  );
};

export default NoInternet;
